import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import colors from "../../theme/colors";
import Item from "../Shared/Style/StyledItem";

export default function Pedidos() {
  const navigate = useNavigate();

  const NavigateTo = (path: string) => {
    navigate(path);
  };

  return (
    <Box sx={{ flexGrow: 1, p: 2, height: '90vh', display: 'flex', flexDirection: 'column' }}>
      <Paper sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Grid container spacing={2}>
          {/* Linha 1 - Cabeçalho e Descrição */}
          <Grid item xs={12}>
            <Paper sx={{ p: 1, bgcolor: '#f8f9fa' }}>
              <h4 style={{ margin: '0 0 0 0', color: colors.bluePrimary, textAlign: 'left' }}>
                🛒 Gestão de Pedidos
              </h4>
              <Typography variant="body2" sx={{ color: '#666', mt: 1 }}>
                Gerenciamento de pedidos e orçamentos
              </Typography>
            </Paper>
          </Grid>

          {/* Linha 2 - Cards de Navegação */}
          <Grid item xs={12}>

              
              <Grid container spacing={2}>
                {/* Card - Gerar Pedidos */}
                <Grid item xs={12} sm={6} md={3}>
                  <Item onClick={() => NavigateTo(`../gerarpedidos`)}>
                    <Box sx={{ 
                      display: 'flex', 
                      flexDirection: 'column', 
                      alignItems: 'center',
                      p: 1
                    }}>
                      <AddShoppingCartIcon
                        sx={{ 
                          color: colors.accent, 
                          fontSize: '2.5em',
                          mb: 1
                        }}
                      />
                      <Typography variant="h6" sx={{ color: colors.bluePrimary, fontWeight: 'bold', mb: 1 }}>
                        Gerar Pedidos
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#666', textAlign: 'center' }}>
                        Criação e gestão de novos pedidos
                      </Typography>
                    </Box>
                  </Item>
                </Grid>

                {/* Card - Consultar Pedidos */}
                <Grid item xs={12} sm={6} md={3}>
                  <Item onClick={() => NavigateTo("../consultarpedidos")}>
                    <Box sx={{ 
                      display: 'flex', 
                      flexDirection: 'column', 
                      alignItems: 'center',
                      p: 1
                    }}>
                      <ShoppingCartIcon
                        sx={{ 
                          color: colors.accent, 
                          fontSize: '2.5em',
                          mb: 1
                        }}
                      />
                      <Typography variant="h6" sx={{ color: colors.bluePrimary, fontWeight: 'bold', mb: 1 }}>
                        Consultar Pedidos
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#666', textAlign: 'center' }}>
                        Consulta de pedidos existentes
                      </Typography>
                    </Box>
                  </Item>
                </Grid>

                {/* Card - Gerar Orçamento */}
                <Grid item xs={12} sm={6} md={3}>
                  <Item onClick={() => NavigateTo("../gerarorcamentos")}>
                    <Box sx={{ 
                      display: 'flex', 
                      flexDirection: 'column', 
                      alignItems: 'center',
                      p: 1
                    }}>
                      <ShoppingCartCheckoutIcon
                        sx={{ 
                          color: colors.orcamento, 
                          fontSize: '2.5em',
                          mb: 1
                        }}
                      />
                      <Typography variant="h6" sx={{ color: colors.orcamento, fontWeight: 'bold', mb: 1 }}>
                        Gerar Orçamento
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#666', textAlign: 'center' }}>
                        Criação de orçamentos para clientes
                      </Typography>
                    </Box>
                  </Item>
                </Grid>

                {/* Card - Consultar Orçamento */}
                <Grid item xs={12} sm={6} md={3}>
                  <Item onClick={() => NavigateTo("../consultarorcamentos")}>
                    <Box sx={{ 
                      display: 'flex', 
                      flexDirection: 'column', 
                      alignItems: 'center',
                      p: 1
                    }}>
                      <ContentPasteSearchIcon
                        sx={{ 
                          color: colors.orcamento, 
                          fontSize: '2.5em',
                          mb: 1
                        }}
                      />
                      <Typography variant="h6" sx={{ color: colors.orcamento, fontWeight: 'bold', mb: 1 }}>
                        Consultar Orçamento
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#666', textAlign: 'center' }}>
                        Pesquisa e visualização de orçamentos
                      </Typography>
                    </Box>
                  </Item>
                </Grid>
              </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}
